export default {
  pages: {
    shippedItems: {
      title: 'Yuk xati',
      items: 'Tovarlar',
      table: {
        name: 'Nom',
        declaredQuantity: 'So‘ralgan miqdor',
        receivedQuantity: 'Olingan miqdor',
      },
      save: 'Saqlash',
      cancel: 'Bekor qilish',
      cancelShipment: "Jo'natmani bekor qilish",
      waybillFile: 'Yuk xati fayli',
      open: 'Ochish',
      successResponse: 'Muvaffaqiyatli saqlandi',
    },
  },
};
